export const zhCNAgentGuiCollaboration = {
  collaborationModeConsult: "咨询",
  collaborationModeFork: "Fork",
  collaborationModeDelegate: "委派",
  collaborationModeHandoff: "Handoff",
  collaborationTriggerUser: "手动",
  collaborationTriggerAgent: "Agent",
  collaborationTriggerPolicy: "策略",
  collaborationStatusRunning: "进行中",
  collaborationStatusCompleted: "已完成",
  collaborationStatusFailed: "失败",
  collaborationStatusCanceled: "已取消",
  collaborationPlanLabel: "方案：{{name}}",
  collaborationUsageTokens: "Tokens：输入 {{input}} · 输出 {{output}}",
  collaborationFailureReason: "失败原因：{{reason}}",
  collaborationResultShow: "查看结果",
  collaborationResultHide: "收起结果",
  collaborationAdopt: "采纳",
  collaborationReject: "不采纳",
  collaborationAdopted: "已采纳",
  collaborationRejected: "未采纳",
  collaborationAdoptionFailed: "记录采纳状态失败",
  composerModelPlanBadge: "方案：{{name}}",
  composerModelSearchPlaceholder: "搜索模型",
  composerModelSearchEmpty: "没有匹配的模型",
  composerModelFavoritesGroup: "收藏",
  composerModelRecentsGroup: "最近使用",
  composerModelSwitchNextTurnHint: "下一次调用生效",
  composerModelFavoriteAdd: "添加到收藏",
  composerModelFavoriteRemove: "取消收藏",
  consultEntryLabel: "咨询模型",
  consultDialogTitle: "咨询模型",
  consultPlanLabel: "方案",
  consultModelLabel: "模型",
  consultQuestionLabel: "问题",
  consultQuestionPlaceholder: "向其他模型咨询建议…",
  consultIncludeContextLabel: "附带当前会话最后回复作为上下文",
  consultSubmit: "发起咨询",
  consultSubmitting: "咨询中…",
  mentionFilterCollab: "协作",
  mentionGroupCollabSessions: "协作会话",
  mentionEmptyCollabSessions: "暂无协作会话",
  mentionCollaboratorFallback: "协作者"
} as const;
